import { Card } from "~/Configurators/Linear/components/Card";
import { Button, Skeleton, type SkeletonProps, Stack, styled } from "@mui/material";
import { CORNER_EXTRA_LARGE } from "~/common/components/icon/Corners";

// Button skeleton component similar to the one in SearchResultSkeleton
const ButtonSkeleton = ({ fullWidth, ...props }: SkeletonProps & { fullWidth?: boolean }) => (
  <Skeleton
    variant="rectangular"
    width={fullWidth ? "100%" : undefined}
    sx={{ borderRadius: CORNER_EXTRA_LARGE }}
    {...props}
  >
    <Button>.</Button>
  </Skeleton>
);

export interface ProductRecommendationTileSkeletonProps {
  /**
   * Optional className to apply to the component
   */
  className?: string;
  itemWidth?: number;
}

const StyledCard = styled(Card)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  padding: "16px",
  background: "white",
}));

const ImageSkeleton = styled(Skeleton)({
  width: "160px",
  height: "120px",
});

/**
 * Skeleton component for ProductRecommendationTile
 * Displays placeholder UI while product data is loading
 */
export const ProductRecommendationTileSkeleton = ({ className, itemWidth }: ProductRecommendationTileSkeletonProps) => {
  return (
    <StyledCard className={className} style={{ width: itemWidth }}>
      <ImageSkeleton />
      <Stack gap={1} sx={{ marginBottom: 2 }}>
        <Skeleton width={"80%"} height={28} />
        <Skeleton width={"95%"} height={20} />
      </Stack>

      <Skeleton width={"50%"} height={24} />
      <ButtonSkeleton fullWidth />
    </StyledCard>
  );
};
